<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">Hauls - Export to PVR</h2>
      </b-col>

      <!--Gear Icon-->
      <b-col lg="6">
        <download-excel
            :data   = "items"
            :fields = "json_fields"
            type    = "csv"
            :name   = "filename">
            <b-btn class="pull-right" v-b-popover.hover.top="'Export to PVR'" variant="info"><i class="fa fa-file-excel-o"></i></b-btn>
        </download-excel>
        <b-btn v-show='send_ftp' class="pull-right ml5" v-b-popover.hover.top="'Send to FTP'" variant="info" @click="SendFTP()"><i class="fa fa-paper-plane-o"></i></b-btn>
      </b-col>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid>
            <!-- Main table element -->
            <b-row>
              <b-col lg="2" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="role =='super_admin'" class="my-1" title="Energy Companies" sm="6" md="2" lg="4">
                <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
                  <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
                  <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col class="my-1 f4" title="Trucking Companies" sm="6" md="2" lg="4">
                  <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.trucking_company_name">
                    <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
                    <b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
                  </b-dropdown>
              </b-col>
              <b-col class="my-1 f9" title="Initial Date" sm="6" md="2" lg="4">
                <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
              </b-col>
              <b-col class="my-1 f10" title="End date" sm="6" md="2" lg="4">
                <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
              </b-col>

              <b-col class="my-1 lg-3 f11" style="max-width: 90px; padding-top: 3px; padding-bottom: 3px;" md="1">
                <b-button style="height: 100%;" @click="clearFilters()">Clear</b-button>
              </b-col>
            </b-row>
            <!-- Shows when loading data-->
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-if="!loadingData" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" >
            </b-table>
            <!-- User Interface controls -->
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"> </div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
            
          </b-container>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import haul_service from './haul_service'
  import moment from 'moment';
  import users_service from '../users/users_service'

  Vue.use(VueSweetalert2)

  const items = []
  export default {
    name: 'hauls',
    created: function() {
      this.Switch_Filters()
    },
    data() {
      return {
        filename : 'report_'+moment().format('YYYYMMDDHHMM')+'.csv',
        json_fields: {
          "TYPE"              :"type",
          "Ticket_Number"     :"ticket",
          "To_location"       :"unload_location_lsd",
          "production_date"   :"haul_start_date",
          "trucking_company"  :"trucking_company",
          "From_location"     :"load_location_lsd",
          "BSW"               :"bsw",  
          "Total Fluid Volume":"volume_actual"
       },
       json_data: [],
       json_meta: [
           [
               {
                   'key': 'charset',
                   'value': 'utf-8'
               }
           ]
       ],
        status:'unchecked',
        insert_data: null,
          selected: '',
        energy_companies_filter   : '',
        load_locations_filter     : '',
        unload_locations_filter   : '',
        trucking_companies_filter :'',
        row: 0,
        loadingData: true,
        trash: false,
        dpdt: "Active",
        filter_by:{"initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id":"", "fluid_type_id":""},
        companyName: '',
        companyId: null,
        configTable: false,
        items: items,
        totalRows: items.length,
        v_items:null,
        fieldsSelected: 8,
        maxFieldsSelected: 24,
        tempFields: [],
        fields: [ {
          key: 'type',
          label: 'Type',
          sortable: true
        },
        {
          key: 'ticket',
          label: 'Ticket_Number',
          sortable: true
        },
        {
          key: 'unload_location_lsd',
          label: 'To location',
          sortable: true
        },
        {
          key: 'haul_start_date',
          label: 'Production date',
          sortable: true,
          formatter:(value) => { return moment(value).format("DD-MMM-YYYY") }
        },
        {
          key: 'trucking_company',
          label: 'Trucking Company',
          sortable: true
        }, 
        {
          key: 'load_location_lsd',
          label: 'From location',
          sortable: true
        }, 
        {
          key: 'bsw',
          label: 'BS&W (%)',
          sortable: true,
          formatter:(value) => { return Number(value.toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" %" }
        }, 
        {
          key: 'volume_actual',
          label: 'Total Fluid Volume',
          sortable: true,
          formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
        }, 
        ],
        currentPage: parseInt(localStorage.haulPage),
        perPage: 25,
        pageOptions: [25, 50, 100],
        filter: null,
        selectedItems: [
          "type",
          "ticket",
          "unload_location_lsd",
          "haul_start_date",
          "trucking_company",
          "load_location_lsd",
          "bsw",  
          "volume_actual"
        ],
				role:'',
				energy_company_id :null,
        unit:'',
        dash:'',
        send_ftp: true,
        filters_save: {
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All UnLoads',
          initial_date            : '',
          end_date                : '',
          flag_name               : 'All Flags',
          sortby                  : 'haul_id',
          sortdesc                : false,
        },
        filters_start: {
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All UnLoads',
          initial_date            : '',
          end_date                : '',
          flag_name               : 'All Flags',
          sortby                  : 'haul_id',
          sortdesc                : false
        }
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      saveSelectedColumns() {
        this.fields = [...this.tempFields]
        this.configTable = false
        haul_service.saveSelectedColumns(this.fields)
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  setTimeout(
                    () => {
                      this.$refs.mEdit.hide()
                    }, 500)
                }
              })
          })
      },
      onFiltered(filteredItems) {
        this.currentPage = parseInt(localStorage.haulPage)
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      clearFilters() {

        this.filter_by = {"initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id":"","fluid_type_id":""}
        this.filters_save = {
          folder_id             : 0,
          folder                : 'All Folders',
          energy_companies_id   : 0,
          energy_company_name   : 'All Energy Companies',
          users_id              : 0,
          driver_name           : 'All Drivers',
          fluid_type_id         : 0,
          fluid_type_name       : 'All Fluid Types',
          trucking_company_id   : 0,
          trucking_company_name : 'All Trucking Companies',
          truck_id              : 0,
          truck_name            : 'All Trucks',
          load_location_id      : 0,
          load_name             : 'All Loads',
          unload_location_id    : 0,
          unload_name           : 'All UnLoads',
          initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
          end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
          flag_name             : 'All Flags',
          sortby                : 'haul_id',
          sortdesc              : false
        }
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      ecFilter(ec_filter,id) {
        this.filter_by['energy_companies_id'] = id

        if (id==0) {
          this.filter_by['energy_companies_id'] = ''
        }
        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_companies_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true

      },
      tcFilter(tc_filter,id) {
        this.filter_by['trucking_company_id'] = id
        if (id==0) {
          this.filter_by['trucking_company_id'] = ''
        }
        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      lFilter(l_filter,id) {
        this.filter_by['load_location_id'] = id
        if (id==0) {
          this.filter_by['load_location_id'] = ''
        }
        this.filters_save.load_name =  l_filter
        this.filters_save.load_location_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.filter_by['unload_location_id'] = id
        if (id==0) {
          this.filter_by['unload_location_id'] = ''
        }
        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_location_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }
        this.filter_by.initial_date = a
        this.filters_save.initial_date = this.filter_by.initial_date
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          this.filters_save.initial_date = ''
        }
        this.filter_by.end_date = a
        this.filters_save.end_date = this.filter_by.end_date
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      getAll() {
        this.selected =''
        this.haul_ids = []
        this.items = []
        haul_service.getAll(this.filter_by)
          .then(data => {
            if (data.status == 'success') {

              this.insert_data                = data.insert_data
              this.energy_companies_filter    = data.energy_companies_filter
              //this.load_locations_filter      = data.load_locations_filter
              //this.unload_locations_filter    = data.unload_locations_filter
              this.trucking_companies_filter  = data.trucking_companies_filter

              let features = data.hauls
              this.items = []
            for (let i = 0; i < features.length; i++) {
              if (features[i].status_id ==  (this.trash ? 2 : 1)) {
                
                let type                ="TICKET"
                let haul_id             = features[i].haul_id
                //let load_location       = features[i].load_location
                
                let load_location_lsd   = features[i].load_location_lsd
                switch (load_location_lsd) {
                  case '0':
                    load_location_lsd       ='OTHER'
                    break
                  case '01-26-075-10W6':
                    load_location_lsd       ='100/04-24-075-10W6/0 (01-26) SWB'
                    break
                  case '04-24-075-10W6':
                    load_location_lsd       ='100/04-24-075-10W6/0 (01-26) SWB'
                    break
                  case '5-24-76-11W6':
                    load_location_lsd       ='102/5-24-76-11W6'
                    break
                  case '06-14-075-09W6':
                    load_location_lsd       ='Valhalla 06-14-075-09W6 BT'
                    break
                  case '06-06-075-10W6':
                    load_location_lsd       ='100/06-06-075-10W6/02'
                    break  
                  case '06-18-074-08W6':
                    load_location_lsd       ='Valhalla 06-18-074-08W6 BT'
                    break
                  case '07-32-073-08W6':
                    load_location_lsd       ='Valhalla 7-32 connoco'
                    break
                  case '8-6-75-9W6':
                    load_location_lsd       ='100/08-06-075-09W6/00'
                    break
                  case '8-7-75-9W6':
                    load_location_lsd       ='100/08-07-075-09W6/00 SWOB'
                    break
                  case '10-17-075-09W6':
                    load_location_lsd       ='100/10-17-075-09W6/02'
                    break
                  case '12-24-072-06W6':
                    load_location_lsd       ='Ocean Fluids & Filtration 12-24-072-06W6'
                    break
                  case '14-18-075-08W6':
                    load_location_lsd       ='Valhalla 102/14-18-075-08W6/02 SWB'
                    break
                  case '14-27-076-11W6':
                    load_location_lsd       ='14-27-076-11W6 Compressor'
                    break
                  case '14-27-76-11W6':
                    load_location_lsd       ='14-27-076-11W6 Compressor'
                    break
                  case '15-06-75-08-W6':
                    load_location_lsd       ='100/06-06-075-10W6/02'
                    break
                  case '15-06-075-08W6':
                    load_location_lsd       ='102/15-06-075-08W6/00'
                    break
                  case '16-14-75-10W6':
                    load_location_lsd       ='100/16-14-075-10W6/00'
                    break
                  case '16-14-75-10W6':
                    load_location_lsd       ='100/16-14-075-10W6/00'
                    break
                  case '102/5-24-76-11W6':
                    load_location_lsd       ='102/05-24-076-11W6/02 Oil'
                    break
                  case '102/11-29-073-08-W6':
                    load_location_lsd       ='(14-32)102/11-29-073-08-W6'
                    break
                  case '103/15-18-075-08W6':
                    load_location_lsd       ='102/10-18-075-08W6'
                    break
                  case 'D Ray Pit D Ray Pit':
                    load_location_lsd       ='D Ray Pit D Ray Pit SE-30-071-10-W6'
                    break
                  case "Ocean'S Fluid":
                    load_location_lsd       ="Ocean Fluids & Filtration 12-24-072-06W6"
                    break
                  case 'Se-30-071-10-W6':
                    load_location_lsd       ='D Ray Pit D Ray Pit SE-30-071-10-W6'
                    break

                }
                //let unload_location     = features[i].unload_location
                let unload_location_lsd = features[i].unload_location_lsd
                switch (unload_location_lsd) {
                  case '0':
                    unload_location_lsd       ='OTHER'
                    break
                  case '06-14-75-09W6':
                    unload_location_lsd       ='Valhalla 06-14-075-09W6 BT'
                    break
                  case '06-14-075-09W6':
                    unload_location_lsd       ='Valhalla 06-14-075-09W6 BT'
                    break
                  case '09-16-069-22W5':
                    unload_location_lsd       ='Tervita Valleyview 09-16-69-22W5'
                    break
                  case '10-19-74-8W6':
                    unload_location_lsd       ='100/10-19-074-08W6/00'
                    break
                  case '102/11-29-073-08W6':
                    unload_location_lsd       ='Valhalla 102/11-29-073-08W6/00'
                    break
                  case '102/15-06-075-08W6':
                    unload_location_lsd       ='102/15-06-075-08W6/00'
                    break
                  case '12-08-073-08W6':
                    unload_location_lsd       ='Tervita LaGlace 12-08-073-08W6'
                    break
                  case '12-31-077-05W6':
                    unload_location_lsd       ='Tervita Spirit River 12-31-077-05W6'
                    break
                  case '12-36-062-020W5':
                    unload_location_lsd       ='Secure Fox 12-36-62-20W5'
                    break
                  case '12-36-062-20W5':
                    unload_location_lsd       ='Secure Fox 12-36-62-20W5'
                    break
                  case '13-08-076-10W6':
                    unload_location_lsd       ='100/13-08-076-10W6/00'
                    break
                  case '15-6-76-10W6':
                    unload_location_lsd       ='Surge Battery 15-6-76-10W6'
                    break
                  case '16-07-073-08W6':
                    unload_location_lsd       ='Secure LaGlace 16-07-073-08W6'
                    break
                  case '16-14-075-09W6':
                    unload_location_lsd       ='Valhalla 06-14-075-09W6 BT'
                    break
                  case 'Secure Laglace':
                    unload_location_lsd       ='Secure LaGlace 16-07-073-08W6'
                    break
                  case 'Surge Battery':
                    unload_location_lsd       ='Surge Battery 15-6-76-10W6'
                    break
                  case 'SW-4-21-075-09W6':
                    unload_location_lsd       ='100/04-24-075-10W6 (01-26)'
                    break
                  case 'Sw-4-21-075-09W6':
                    unload_location_lsd       ='100/04-24-075-10W6 (01-26)'
                    break
                  case 'Tervita Judy Creek':
                    unload_location_lsd       ='Tervita Judy Creek 04-05-063-11W5'
                    break
                  case 'Tervita Laglace':
                    unload_location_lsd       ='Tervita LaGlace 12-08-073-08W6'
                    break
                  case 'Tervita Spirit River':
                    unload_location_lsd       ='Tervita Spirit River 12-31-077-05W6'
                    break
                  case 'Tervita Valleyview':
                    unload_location_lsd       ='Tervita Valleyview 09-16-69-22W5'
                    break
                }
                let ticket              = features[i].ticket

                if (features[i].oil_actual.indexOf('bbl')!= -1) {
                  this.unit=' bbl'
                } else {
                  this.unit=' m³'
                }
                let volume_actual       = features[i].volume_actual
                let bsw                 = features[i].bsw
                let energy_company      = features[i].energy_company
                let haul_start_date     = features[i].haul_start_date
                let volume              = features[i].volume
                let f_bsw               = features[i].f_bsw
                let truck_company       = features[i].truck_company

                let _data = {
                  "type"                : type,
                  "haul_id"             : haul_id,
                  //"load_location"       : load_location,
                  "load_location_lsd"   : load_location_lsd,
                  //"unload_location"     : unload_location,
                  "unload_location_lsd" : unload_location_lsd,
                  "ticket"              : ticket,
                  "volume_actual"       : parseFloat(volume_actual.replace(this.unit, "")),
                  "bsw"                 : parseFloat(bsw.replace("%", "")),
                  "energy_company"      : energy_company,
                  "haul_start_date"     : moment(haul_start_date).format('DD-MMM-YYYY'),
                  "trucking_company"    : truck_company,
                }
                    this.items.push(_data)
                }
              }
  						this.role = data.role
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      saveFilters() {
        haul_service.saveFilters(1,this.filters_save)
          .then((data) => {
                if (data[0] == 'success') {
                    return
                } else {
                    Vue.swal(data[0], data[1], data[0])
                    return
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            return
          })
    },
    getFilters() {
        haul_service.getFilters(1)
          .then((data) => {
                if (data[0] == 'success') {
                    this.filters_start  = data[1]
                    this.filters_start1 = data[2]
                    if (this.filters_start.length != 0) {
                      // Code Changed and Optimized
                      for (var property in this.filters_start[0]) {
                        this.filters_save[property]   = this.filters_start[0][property]
                        if (this.filters_start[0][property] == 0){
                            this.filter_by[property] = ""
                        } else if (this.filters_start[0][property] == null){
                            this.filter_by[property] = ""
                        } else {
                              this.filter_by[property] = this.filters_start[0][property]
                        }
                      } // for
                      if(this.filters_start[0]['initial_date'] == null)
                      {
                          this.filter_by['initial_date'] = moment().startOf('month').format('YYYY-MM-DD')
                          this.filters_save['initial_date'] = moment().startOf('month').format('YYYY-MM-DD')
                      }
                      if(this.filters_start[0]['end_date'] == null)
                      {
                        this.filter_by['end_date'] = moment().endOf('month').format('YYYY-MM-DD')
                        this.filters_save['end_date'] = moment().endOf('month').format('YYYY-MM-DD')
                      }

                      for (var property in this.filters_start1[0]) {
                        this.filters_save[property]   = this.filters_start1[0][property]
                      } // for

                      if (this.filters_start[0].folder_id == 0 && this.filters_start1[0].folder == 'Unassigned Hauls') {
                        this.filter_by.folder_id = this.filters_start[0].folder_id
                      }
                      this.filters_save.folder_id             = this.filters_start[0].folder_id
                      this.filters_save.folder                = this.filters_start1[0].folder

                    } else {
                        this.filters_save.folder_id             = 0
                        this.filters_save.folder                = "All Folders"
                        this.filters_save.energy_companies_id   = 0
                        this.filters_save.energy_company_name   = "All Energy Companies"
                        this.filters_save.fluid_type_id         = 0
                        this.filters_save.fluid_type_name       = "All Fluid Types"
                        this.filters_save.users_id              = 0
                        this.filters_save.driver_name           = "All Drivers"
                        this.filters_save.truck_id              = 0
                        this.filters_save.truck_name            = "All Trucks"
                        this.filters_save.trucking_company_id   = 0
                        this.filters_save.trucking_company_name = "All Trucking Companies"
                        this.filters_save.unload_location_id    = 0
                        this.filters_save.load_name             = "All Loads"
                        this.filters_save.unload_location_id    = 0
                        this.filters_save.unload_name           = "All Unloads"
                        this.filters_save.flag_name             = "All Flags"
                        this.filters_save.initial_date          = moment().startOf('month').format('YYYY-MM-DD')
                        this.filters_save.end_date              = moment().endOf('month').format('YYYY-MM-DD')
                        this.filters_save.sortby                = 'haul_id'
                        this.filters_save.sortdesc              = false
                        this.filter_by={"initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "","folder_id":"","fluid_type_id":""}
                    }
                    this.getAll()
                    this.loadingData = true
                } else {
                    Vue.swal(data[0], data[1], data[0])
                    this.loadingData = false
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
    },
    sortingChanged (ctx) {
      this.filters_save.sortdesc  = ctx.sortDesc
      this.filters_save.sortby    = ctx.sortBy
      this.saveFilters()
    },
    Switch_Filters(){
      
      if("dashboard" in localStorage){
        this.dash=localStorage.getItem('dashboard')
      } else {
        this.dash="dash00"
      }
      if (this.dash=="dash00"){
          localStorage.setItem('dashboard', 'dash00')
          this.getFilters()
      } else {
          this.filters_save.folder_id             = 0
          this.filters_save.folder                = "All Folders"
          this.filters_save.energy_companies_id   = 0
          this.filters_save.fluid_type_id         = 0
          this.filters_save.fluid_type_name       = "All Fluid Types"
          this.filters_save.users_id              = 0
          this.filters_save.driver_name           = "All Drivers"
          this.filters_save.truck_id              = 0
          this.filters_save.truck_name            = "All Trucks"
          this.filters_save.trucking_company_id   = 0
          this.filters_save.trucking_company_name = "All Trucking Companies"
          this.filters_save.load_location_id    = 0
          this.filters_save.load_name             = "All Loads"
          this.filters_save.unload_location_id    = 0
          this.filters_save.unload_name           = "All Unloads"
          this.filters_save.flag_name             = "All Flags"
          this.filters_save.sortby                = 'haul_id'
          this.filters_save.sortdesc              = false
          this.filter_by={"initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "","folder_id":"","fluid_type_id":""}

          //this.dash_energy_companies_id            = localStorage.getItem('dashboard_energy_id')
          //this.dash_energy_companies_name          = localStorage.getItem('dashboard_energy_name')
          //this.dash_start_date                     = localStorage.getItem('dashboard_start_date')
          //this.dash_end_date                       = localStorage.getItem('dashboard_end_date')

          this.filter_by.initial_date             = localStorage.getItem('dashboard_start_date')
          this.filter_by.end_date                 = localStorage.getItem('dashboard_end_date')
          this.filter_by.energy_companies_id      = localStorage.getItem('dashboard_energy_id')
          this.filters_save.energy_company_name   = localStorage.getItem('dashboard_energy_name')

          if("dashboard_trucking_company_id" in localStorage){
            if (localStorage.getItem('dashboard_trucking_company_id') != '') {
              this.filters_save.trucking_company_id = localStorage.getItem('dashboard_trucking_company_id')
              this.filter_by.trucking_company_id    = this.filters_save.trucking_company_id
            } else {
              this.filters_save.trucking_company_id = 0
              this.filter_by.trucking_company_id    = ''
            }
          } else {
              this.filters_save.trucking_company_id = 0
              this.filter_by.trucking_company_id    = ''
          }

         if("dashboard_trucking_company_name" in localStorage){
            if (localStorage.getItem('dashboard_trucking_company_name') != '') {
              this.filters_save.trucking_company_name = localStorage.getItem('dashboard_trucking_company_name')
            } else {
              this.filters_save.trucking_company_name = "All Trucking Companies"
            }
          } else {
              this.filters_save.trucking_company_name = "All Trucking Companies"
          }

          if (this.dash=='dash03'){
            this.filters_save.unload_location_id    = localStorage.getItem('dashboard_location_id')
            this.filter_by.unload_location_id       = this.filters_save.unload_location_id
            this.filters_save.unload_name           = localStorage.getItem('dashboard_location_name')
            localStorage.removeItem('dashboard_location_id');
            localStorage.removeItem('dashboard_location_name');
          }

          if (this.dash=='dash04'|| this.dash=='dash06'|| this.dash=='dash07'){
            this.filters_save.unload_location_id    = localStorage.getItem('dashboard_location_id')
            this.filter_by.unload_location_id       = this.filters_save.unload_location_id
            this.filters_save.unload_name           = localStorage.getItem('dashboard_location_name')
            this.filters_save.fluid_type_id         = localStorage.getItem('dashboard_fluid_type_id')
            this.filter_by.fluid_type_id            = this.filters_save.fluid_type_id
            this.filters_save.fluid_type_name       = localStorage.getItem('dashboard_fluid_type_name')

            localStorage.removeItem('dashboard_location_id');
            localStorage.removeItem('dashboard_location_name');
            localStorage.removeItem('dashboard_fluid_type_id');
            localStorage.removeItem('dashboard_fluid_type_name');

          }

          if (this.dash=='dash05'){
            this.filters_save.load_location_id    = localStorage.getItem('dashboard_location_id')
            this.filter_by.load_location_id       = this.filters_save.load_location_id
            this.filters_save.load_name           = localStorage.getItem('dashboard_location_name')
            this.filters_save.fluid_type_id       = localStorage.getItem('dashboard_fluid_type_id')
            this.filter_by.fluid_type_id          = this.filters_save.fluid_type_id
            this.filters_save.fluid_type_name     = localStorage.getItem('dashboard_fluid_type_name')

            localStorage.removeItem('dashboard_location_id');
            localStorage.removeItem('dashboard_location_name');
            localStorage.removeItem('dashboard_fluid_type_id');
            localStorage.removeItem('dashboard_fluid_type_name');

          }

          if (this.dash=='dash08'){
            this.filters_save.flag_name     = localStorage.getItem('dashboard_flag_name')
            localStorage.removeItem('dashboard_flag_name');
          }

          localStorage.setItem('dashboard', 'dash00')
          localStorage.removeItem("dashboard_start_date");
          localStorage.removeItem("dashboard_end_date");
          localStorage.removeItem('dashboard_energy_id');
          localStorage.removeItem('dashboard_energy_name');
          localStorage.removeItem('dashboard_trucking_company_id');
          localStorage.removeItem('dashboard_trucking_company_name');
          this.getAll()
          this.loadingData = true

      }
    },
    SendFTP() {
     if (this.filters_save.energy_company_name==='Surge Energy') {
        let filter_ftp = {
          initial_date: this.filter_by.initial_date,
          end_date: this.filter_by.end_date,
          trucking_company_id: this.filter_by.trucking_company_id
        }
        this.send_ftp=false
        haul_service.sendFTP(filter_ftp)
          .then(data => {
            if (data.status == 'success') {
              this.$swal(data.status, data.message, data.status)
              this.send_ftp=true
              return
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.send_ftp=true
              return
            }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.send_ftp=true
          })
      }
    }
  }
}
</script>

<style>
  .table tbody tr:hover {
    background-color: rgb(222, 225, 229);
    color: #030303;
    cursor: pointer;
  }

  table div {
    padding: 0.75rem;
  }

  .table td {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/hauls/export.vue